import React, { Component } from 'react';
import divisaomgh from '../data/divisaomgh.json';
import conjuntodocumental from '../data/conjuntodocumental.json';
import tipodocumental from '../data/tipodocumental.json';
import { Link } from 'react-router-dom';

class Filters extends Component {
  state = {};
  render() {
    const {
      filter,
      handleChangeSelect,
      handleChangeInput,
      handleCleanFilters,
      handleDownloadAsCSV,
      handleDownloadAsJSON,
      dataLength,
    } = this.props;
    return (
      <div className="filters">
        <div className="container">
          <div className="row filter-header">
            <div className="col align-self-center">
              <Link to="/">
                <h1 className="filter-title d-inline">PaupeR</h1>
              </Link>
            </div>
            <div className="col-2 align-self-center">
              <p className="text-end">
                Exibindo <b>{dataLength}</b>{' '}
                {dataLength === 1 ? 'ocorrência' : 'ocorrências'}.
              </p>
            </div>
            <div className="col-auto align-self-center">
              <button
                className="btn btn-sm btn-light downloadButton"
                onClick={handleDownloadAsCSV}
              >
                Baixar seleção como CSV
                <i class="fas fa-download ms-2"></i>
              </button>
              <button
                className="btn btn-sm btn-light downloadButton ms-3"
                onClick={handleDownloadAsJSON}
              >
                Baixar seleção como JSON
                <i class="fas fa-download ms-2"></i>
              </button>
            </div>
          </div>
          <hr />
          <div className="row g-3 mb-3">
            <div className="col">
              <label htmlFor="palavraChave" className="form-label">
                Palavra-chave
              </label>
              <input
                id="palavraChave"
                className="form-control form-control-sm"
                onChange={(e) => handleChangeInput(e)}
                value={filter.termSearch}
              ></input>
            </div>
            <div className="col">
              <label htmlFor="lema" className="form-label">
                Lema
              </label>
              <select
                id="lema"
                className="form-select form-select-sm"
                onChange={(e) => handleChangeSelect(e, 'lema')}
                value={filter.lema}
              >
                <option />
                <option value="pauper">Pauper</option>
                <option value="egens">Egens</option>
                <option value="inops">Inops</option>
                <option value="mendicus">Mendicus</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="divisaoMgh" className="form-label">
                Divisão MGH
              </label>
              <select
                id="divisaoMgh"
                className="form-select form-select-sm"
                onChange={(e) => handleChangeSelect(e, 'divisao_mgh')}
                value={filter.divisao_mgh}
              >
                <option />
                {divisaomgh.sort().map((option) => (
                  <option
                    key={`select-${option}`}
                    value={option}
                    selected={filter.divisao_mgh === option}
                  >
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label htmlFor="conjuntoDocumental" className="form-label">
                Conjunto Documental
              </label>
              <select
                id="conjuntoDocumental"
                className="form-select form-select-sm"
                onChange={(e) => handleChangeSelect(e, 'conjunto_documental')}
                value={filter.conjunto_documental}
              >
                <option />
                {conjuntodocumental.sort().map((option) => (
                  <option key={`select-${option}`} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label htmlFor="tipoDocumental" className="form-label">
                Tipo Documental
              </label>
              <select
                id="tipoDocumental"
                className="form-select form-select-sm"
                onChange={(e) => handleChangeSelect(e, 'tipo_documental')}
                value={filter.tipo_documental}
              >
                <option />
                {tipodocumental.sort().map((option) => (
                  <option key={`select-${option}`} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-auto align-self-end">
              <button
                className="btn btn-sm btn-primary"
                onClick={handleCleanFilters}
              >
                Limpar Filtros
                <i className="fas fa-trash-alt ms-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Filters;
